'use client'

import { ErrorFallback } from '@components/Layout/ErrorFallback'
import { type ReportableError } from '@hooks/useReportError'

type DashboardErrorProps = {
  error: ReportableError
  reset: () => void
}

export default function DashboardError({ error, reset }: DashboardErrorProps) {
  return (
    <div className='flex flex-1 items-center justify-center p-4'>
      <ErrorFallback error={error} reset={reset} source='dashboard-segment-boundary' />
    </div>
  )
}
